module.exports = __webpack_public_path__ + "fonts/BalbeerRustic.4a146f0.woff";